/*
 * 报表管理接口
 * */
import services from "../config/axios";
import base from './base';

const reportManageAPI = {
  // 获取今日运行情况
  getChartDayRun<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartDayRun`, params);
  },
  // 获取本月运行情况
  getChartMonthRun<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartMonthRun`, params);
  },
  // 获取运行时间统计
  getChartTime<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartTime`, params);
  },
  // 获取流程运行总次数
  getChartTotalCount<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartTotalCount`, params);
  },
  // 获取流程运行总时长
  getChartTotalTime<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartTotalTime`, params);
  },
  // 获取流程月份成功率
  getChartMonthSucRate<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartMonthSucRate`, params);
  },
  // 获取流程明细
  getChartDetails<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetChartDetails`, params);
  },
  // 获取流程明质量排名
  getQualityRanking<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetQualityRanking`, params);
  },
  // 获取RPA使用情况
  getRPAUseRate<T>(params: FormData) {
    return services.post(`${base.lk}/Report/GetRPAUseRate`, params);
  },
};

export default reportManageAPI;
